import { effect, inject, Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'portal/core/language/language.service';

@Injectable()
export class PaginatorIntlService extends MatPaginatorIntl {
  readonly #language = inject(LanguageService);
  readonly #translate = inject(TranslateService);

  constructor() {
    super();

    effect(() => {
      this.#language.language();
      this.#getTranslations();
    });

    this.#getTranslations();
  }

  #getTranslations(): void {
    this.itemsPerPageLabel = this.#translate.instant('common.paginator.items-per-page');
    this.nextPageLabel = this.#translate.instant('common.paginator.next-page');
    this.previousPageLabel = this.#translate.instant('common.paginator.previous-page');
    this.firstPageLabel = this.#translate.instant('common.paginator.first-page');
    this.lastPageLabel = this.#translate.instant('common.paginator.last-page');
    this.getRangeLabel = (page: number, pageSize: number, length: number) => {
      const text = this.#translate.instant('common.paginator.range-of');
      if (length === 0 || pageSize === 0) {
        return `0 ${text} ${length}`;
      }
      const startIndex = page * pageSize;
      const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
      return `${startIndex + 1} – ${endIndex} ${text} ${length}`;
    };

    this.changes.next();
  }
}
